import { render, staticRenderFns } from "./vz.vue?vue&type=template&id=00a3bbfe&scoped=true&"
import script from "./vz.vue?vue&type=script&lang=js&"
export * from "./vz.vue?vue&type=script&lang=js&"
import style0 from "./vz.vue?vue&type=style&index=0&id=00a3bbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3bbfe",
  null
  
)

export default component.exports